import React from 'react';
import Context from '../../assets/js/Context';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import Component from "@reactions/component";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import StorageIcon from '@material-ui/icons/Storage';
import BuildIcon from '@material-ui/icons/Build';

import INV from '../../assets/img/in.jpg';
import SN from '../../assets/img/sn.webp';

import { Pane, Dialog, Spinner, SideSheet, Position } from 'evergreen-ui';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Login from '../common/login';

const cookies = new Cookies();
const role = Number(localStorage.getItem('role'));

// Styled Components
const styles = {
  pageContainer: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    direction: 'rtl',
    fontFamily: 'Cairo, Arial, sans-serif',
    paddingTop: '80px'
  },
  
  headerSection: {
    textAlign: 'center',
    marginBottom: '50px',
    padding: '20px',
    animation: 'fadeInDown 0.8s ease-out'
  },
  
  pageTitle: {
    fontSize: '3rem',
    fontWeight: 'bold',
    color: '#2c3e50',
    marginBottom: '10px',
    textShadow: '2px 2px 4px rgba(0,0,0,0.1)'
  },
  
  pageSubtitle: {
    fontSize: '1.2rem',
    color: '#7f8c8d',
    fontWeight: '300'
  },
  
  cardsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '30px',
    padding: '0 20px',
    maxWidth: '1200px',
    margin: '0 auto'
  },
  
  categoryCard: {
    background: '#ffffff',
    borderRadius: '20px',
    padding: '30px',
    width: '280px',
    height: '320px',
    boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
    transition: 'all 0.3s ease',
    position: 'relative',
    overflow: 'hidden',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    '&:hover': {
      transform: 'translateY(-10px)',
      boxShadow: '0 20px 40px rgba(0,0,0,0.15)'
    }
  },
  
  cardBeforeEffect: {
    content: '""',
    position: 'absolute',
    top: '-50%',
    left: '-50%',
    width: '200%',
    height: '200%',
    background: 'linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.5) 50%, transparent 70%)',
    transform: 'rotate(45deg)',
    transition: 'all 0.5s ease',
    opacity: 0
  },
  
  iconContainer: {
    width: '120px',
    height: '120px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '20px',
    transition: 'all 0.3s ease'
  },
  
  iconContainerStorage: {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    boxShadow: '0 10px 20px rgba(102, 126, 234, 0.3)'
  },
  
  iconContainerMaintenance: {
    background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    boxShadow: '0 10px 20px rgba(245, 87, 108, 0.3)'
  },
  
  cardIcon: {
    fontSize: '60px',
    color: '#ffffff'
  },
  
  cardImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '50%'
  },
  
  cardTitle: {
    fontSize: '1.5rem',
    fontWeight: '600',
    color: '#2c3e50',
    textAlign: 'center',
    marginTop: '10px'
  },
  
  cardDescription: {
    fontSize: '0.9rem',
    color: '#95a5a6',
    textAlign: 'center',
    marginTop: '10px'
  },
  
  spinnerContainer: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)'
  },
  
  customSpinner: {
    width: '60px',
    height: '60px',
    border: '3px solid rgba(102, 126, 234, 0.2)',
    borderTopColor: '#667eea',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite'
  }
};

// CSS Animations
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = `
  @import url('https://fonts.googleapis.com/css2?family=Cairo:wght@300;400;600;700&display=swap');
  
  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translateY(-30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: scale(0.9);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
  
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
  
  .category-card {
    background: #ffffff;
    border-radius: 20px;
    padding: 30px;
    width: 280px;
    height: 320px;
    box-shadow: 0 10px 30px rgba(0,0,0,0.1);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    animation: fadeIn 0.6s ease-out;
  }
  
  .category-card:hover {
    transform: translateY(-10px) scale(1.02);
    box-shadow: 0 20px 40px rgba(0,0,0,0.15);
  }
  
  .category-card:hover .icon-container {
    transform: scale(1.1);
  }
  
  .category-card::before {
    content: "";
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.5) 50%, transparent 70%);
    transform: rotate(45deg) translateX(-100%);
    transition: all 0.6s ease;
  }
  
  .category-card:hover::before {
    transform: rotate(45deg) translateX(100%);
  }
  
  .icon-container {
    transition: all 0.3s ease;
  }
  
  .pulse {
    animation: pulse 2s infinite;
  }
  
  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(102, 126, 234, 0.4);
    }
    70% {
      box-shadow: 0 0 0 20px rgba(102, 126, 234, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(102, 126, 234, 0);
    }
  }
`;
document.head.appendChild(styleSheet);

class Category extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            nameCate: '',
            image: [],
            Category: [],
            spin: false,
        }
    }

    componentDidMount() {
        var header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };
        axios.get(host + `dashbord/category`, { headers: header })
            .then(res => {
                var arr = [];
                for (let i = 0; i < res.data.data.categories.length; i++) {
                    if (res.data.data.categories[i].is_count) {
                        arr.push(res.data.data.categories[i]);
                    }
                }
                this.setState({
                    Category: arr,
                    spin: true
                });
            })
            .catch(error => { console.log(error.response) })
    }

    EditCate(id) {
        var header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };
        let formData = new FormData();
        formData.append("name", this.state.nameCate);
        formData.append("is_count", 1);
        formData.append("file", this.state.image[0]);
        axios({ url: host + `dashbord/category/${id}`, method: "PUT", data: formData, headers: header })
            .then(response => {
                this.setState({ image: '' })
                this.componentDidMount()
                toast.success('تم التعديل بنجاح ✓', {
                    position: "bottom-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    style: {
                        fontFamily: 'Cairo, Arial, sans-serif',
                        direction: 'rtl'
                    }
                });
            })
            .catch(error => { console.log(error.response.data.message) })
    }

    DeleteCate(id) {
        var header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };
        axios.delete(host + `dashbord/category/${id}?`, { headers: header })
            .then(response => {
                toast.error('تم الحذف بنجاح', {
                    position: "bottom-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    style: {
                        fontFamily: 'Cairo, Arial, sans-serif',
                        direction: 'rtl'
                    }
                });
                this.componentDidMount();
            })
            .catch(error => { console.log(error.response.data.message) })
    }

    AddCate() {
        var header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };
        let formData = new FormData();
        formData.append("name", this.state.nameCate);
        formData.append("is_count", 1);
        formData.append("file", this.state.image[0]);
        axios({ url: host + `dashbord/category`, method: "POST", data: formData, headers: header })
            .then(response => {
                this.componentDidMount();
                toast.success('تم اضافة القسم بنجاح ✓', {
                    position: "bottom-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    style: {
                        fontFamily: 'Cairo, Arial, sans-serif',
                        direction: 'rtl'
                    }
                });
            })
            .catch(error => { console.log(error.response.data.message) })
    }

    render() {
        if (cookies.get("token")) {
            return (
                <Context.Consumer>
                    {ctx => {
                        if (this.state.spin) {
                            return (
                                <div style={styles.pageContainer}>
                                    <div id='navDashContiner'></div>

                                    {/* Header Section */}
                                    <div style={styles.headerSection}>
                                        <h1 style={styles.pageTitle}>إدارة المخازن</h1>
                                        <p style={styles.pageSubtitle}>اختر المخزن المناسب للوصول إلى المواد</p>
                                    </div>

                                    {/* Cards Container */}
                                    <div style={styles.cardsContainer}>
                                        {/* مخزن المواد - يظهر للجميع */}
                                        <Link to={`/Items2Dash/1`} style={{ textDecoration: 'none' }}>
                                            <div className="category-card">
                                                <div 
                                                    className="icon-container pulse" 
                                                    style={styles.iconContainerStorage}
                                                >
                                                    {INV ? 
                                                        <img src={INV} alt='مخزن المواد' style={styles.cardImage} />
                                                        : 
                                                        <StorageIcon style={styles.cardIcon} />
                                                    }
                                                </div>
                                                <h3 style={styles.cardTitle}>مخزن المواد</h3>
                                                <p style={styles.cardDescription}>
                                                    إدارة وتنظيم جميع المواد المتاحة في المخزن الرئيسي
                                                </p>
                                            </div>
                                        </Link>

                                        {/* مخزن الصيانة - يظهر فقط إذا لم يكن الدور = 2 */}
                                        {role !== 2 && (
                                            <Link to={`/ItemsSana/2`} style={{ textDecoration: 'none' }}>
                                                <div className="category-card" style={{ animationDelay: '0.2s' }}>
                                                    <div 
                                                        className="icon-container pulse" 
                                                        style={styles.iconContainerMaintenance}
                                                    >
                                                        {SN ? 
                                                            <img src={SN} alt='مخزن الصيانة' style={styles.cardImage} />
                                                            : 
                                                            <BuildIcon style={styles.cardIcon} />
                                                        }
                                                    </div>
                                                    <h3 style={styles.cardTitle}>مخزن الصيانة</h3>
                                                    <p style={styles.cardDescription}>
                                                        إدارة قطع الغيار وأدوات الصيانة المختلفة
                                                    </p>
                                                </div>
                                            </Link>
                                        )}
                                    </div>

                                    <ToastContainer
                                        position="bottom-left"
                                        autoClose={10000}
                                        hideProgressBar={false}
                                        newestOnTop={false}
                                        closeOnClick
                                        rtl={true}
                                        pauseOnVisibilityChange
                                        draggable
                                        pauseOnHover
                                    />
                                </div>
                            );
                        } else {
                            return (
                                <div style={styles.spinnerContainer}>
                                    <div style={styles.customSpinner}></div>
                                </div>
                            );
                        }
                    }}
                </Context.Consumer>
            );
        } else {
            return <Login />;
        }
    }
}

export default Category;